<script setup lang="ts">
import { computed } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { formatDate } from '@/utils/dateUtils';
import { tourTypeList } from '@/constants';
import capitalize from 'lodash/capitalize';
import InputText from 'primevue/inputtext';

const props = defineProps<{
  listSelectedTour: Array<any>;
  tourForm: object;
  tourIndex: number;
}>();

const emits = defineEmits<{
  openEditTour: [isEdit: boolean, data: any];
  'update:listSelectedTour': [value: any];
  'update:tourForm': [value: any];
}>();

const currentLanguage = getCurrentLocale();
const langCapitalize = capitalize(currentLanguage);

const listSelectedTour = computed({
  get() {
    return props.listSelectedTour;
  },
  set(value) {
    emits('update:listSelectedTour', value);
  }
});

const tourDetail = computed({
  get() {
    return props.tourForm;
  },
  set(value) {
    emits('update:tourForm', value);
  }
});

const openEditModal = () => {
  emits('openEditTour', true, []);
};
const convertTour = (tour: any) => {
  tourDetail.value.tours = listSelectedTour.value;
  const tourName = tour[`tourName${langCapitalize}`];
  const tourInclusion = tour[`tourInclusions${langCapitalize}`];
  const tourTitle = tour[`title${langCapitalize}`];
  return `${convertDate(tour.depDate)} ${convertNameAndDetail(tourName, tourInclusion)} ${convertTitleAndType(tourTitle, tour.type)}`;
};

const convertDate = (date: any) => {
  return `(${formatDate(date, 'dd-LLL-yyyy', true, currentLanguage)})`;
};

const convertNameAndDetail = (name: any, detail: any) => {
  return `${name} - ${detail ?? ''}`;
};

const convertTitleAndType = (title: any, type: any) => {
  return `(${title})  ${type ? '- ' + handleReplaceNameToValue(type) : ''}`;
};

const checkIndex = (getIndex: number) => {
  return getIndex == 0 && props.tourIndex == 0;
};

const handleReplaceNameToValue = (value: any) => {
  if (!isNaN(value)) {
    return tourTypeList.find((tourType: any) => tourType.value == value)[`name${langCapitalize}`];
  } else {
    return value;
  }
};
</script>
<template>
  <div class="mt-2 tour-after">
    <div class="mb-5" v-for="(tour, index) in listSelectedTour" :key="index">
      <div class="flex justify-content-between">
        <div>{{ $t('common.tour') + ' ' + (index + 1) }}</div>
        <div v-if="checkIndex(index)" @click="openEditModal()" class="flex edit-color justify-content-end cursor-pointer selected-our-class">{{ $t('multi_day_tour.edit_selected_tour') }}</div>
      </div>
      <InputText disabled :modelValue="convertTour(tour)" focus type="text" class="w-full mt-2" />
    </div>
  </div>
</template>
